<template>
    <a
        class="group"
        :class="projectClass"
        :href="project.url"
    >
        <div class="flex flex-col">
            <div class="flex-1 relative overflow-hidden">
                <img
                    v-if="featuredImage"
                    class="block absolute left-0 top-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-in-out"
                    :src="featuredImage.url"
                    :srcset="featuredImage.srcset"
                    :alt="project.title"
                    loading="lazy"
                />

                <div class="block absolute h-0 bottom-0 inset-x-0 bg-secondary-500 group-hover:h-12 transition-all duration-300 ease-in-out" />

                <arrow-right class="absolute bottom-3 right-3 text-white w-5 h-auto -rotate-45 group-hover:rotate-0 transition-transform duration-300 ease-in-out" />
            </div>

            <div class="pt-3">
                <div class="">
                    <span class="inline-block align-middle w-3 h-3 mr-2 -mt-[3px] bg-secondary-500 rounded-full" />

                    <h2 class="h6 inline pr-2 border-r-2 border-secondary-500">{{ project.title }}</h2>

                    <span
                        v-for="l in projectLocation"
                        :key="l"
                        class="h6 px-2 !font-light text-gray-500 border-r-2 border-secondary-500 last:border-r-0 last:pr-0"
                    >{{ l }}</span>
                </div>
            </div>
        </div>
    </a>
</template>

<script setup>
    import { computed } from 'vue';
    import ArrowRight from '@/img/icons/arrow-right.svg?component';

    const props = defineProps({
        project: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    });

    const SPAN_WIDE = 'col-span-1 lg:col-span-2 aspect-w-4 aspect-h-3';
    const SPAN_NARROW = 'col-span-1 aspect-w-4 lg:aspect-w-2 aspect-h-3';

    const spans = [
        SPAN_WIDE,
        SPAN_NARROW,

        SPAN_NARROW,
        SPAN_NARROW,
        SPAN_NARROW,

        SPAN_NARROW,
        SPAN_WIDE,

        SPAN_NARROW,
        SPAN_NARROW,
        SPAN_NARROW,
    ];

    const projectClass = computed(() => spans[props.index % spans.length]);
    const featuredImage = computed(() => {
        if (projectClass.value === SPAN_NARROW && window.innerWidth > 1024) {
            return props.project.featuredImageNarrow[0] ?? null;
        }

        return props.project.featuredImageWide[0] ?? null;

    });

    const projectLocation = computed(() => props.project.location.split('|').map(l => l.trim()));
</script>
